import { Middleware } from '@reduxjs/toolkit';

import actions from './listeners/actions';
import balance from './listeners/balance';
import cacheManagement from './listeners/cacheManagement';
import catalogs from './listeners/catalogs';
import category from './listeners/category';
import commands from './listeners/commands';
import confirmationDialog from './listeners/confirmationDialog';
import connection from './listeners/connection';
import content from './listeners/content';
import dataset from './listeners/dataset';
import dictionary from './listeners/dictionary';
import docLinksGraph from './listeners/docLinksGraph';
import error from './listeners/error';
import form from './listeners/form';
import hierarchy from './listeners/hierarchy';
import menu from './listeners/menu';
import notifications from './listeners/notifications';
import pivotReport from './listeners/pivotReport';
import review from './listeners/review';
import rolePrivs from './listeners/rolePrivs';
import schemaManagement from './listeners/schemaManagement';
import session from './listeners/session';
import systemNotifications from './listeners/systemNotifications';
import theme from './listeners/theme';
import userConfig from './listeners/userConfig';
import workTable from './listeners/workTable';

const middleware: Middleware[] = [
  actions,
  balance,
  cacheManagement,
  catalogs,
  commands,
  confirmationDialog,
  connection,
  content,
  category,
  dataset,
  dictionary,
  docLinksGraph,
  error,
  hierarchy,
  menu,
  notifications,
  pivotReport,
  form,
  review,
  rolePrivs,
  schemaManagement,
  session,
  systemNotifications,
  theme,
  userConfig,
  workTable,
];

export default middleware;
